<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col p-mt-4 p-ml-3">
                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ev_station_name">ชื่อสถานีชาร์จรถยนต์ไฟฟ้า</label>
                                <InputText
                                    id="ev_station_name"
                                    type="text"
                                    v-model="search_ev_station_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ev_station_dealer">ตัวแทนจำหน่าย</label>
                                <InputText
                                    id="ev_station_dealer"
                                    type="text"
                                    v-model="search_ev_station_dealer"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ev_station_brand">ผู้ให้บริการ</label>
                                <InputText
                                    id="ev_station_brand"
                                    type="text"
                                    v-model="search_ev_station_brand"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ev_station_status">สถานะ</label>
                                <InputText
                                    id="ev_station_status"
                                    type="text"
                                    v-model="search_ev_station_status"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="fireStation">สถานีดับเพลิงและกู้ภัย<span class="required-input">*</span></label>
                                <Dropdown
                                    v-model="fireStation"
                                    :options="FireStationOptions_AT"
                                    optionLabel="fs_tname"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                    required="true"
                                    :class="{ 'p-invalid': error_fireStation && !FireStationSelected }"
                                >
                                    <template #value="FireStationOptions_AT">
                                        <div v-if="FireStationOptions_AT.value">
                                            <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                        </div>
                                        <span v-else>{{ FireStationOptions_AT.placeholder }}</span>
                                    </template>
                                    <template #option="FireStationOptions_AT">
                                        <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    v-if="window.width <= 430"
                                    @click="MobileClearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <Button
                                    v-else
                                    @click="clearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    @click="searchEvStationInfo()"
                                    :label="$t('searchBtn')"
                                    class="p-button-info"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="evStationInfo_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? evStationInfo_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :sortOrder="1"
                sortField="index"
                dataKey="ev_station_id"
                ref="dt"
                :exportFilename="`ข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า-${date}`"
                :rowHover="true"
                :selection.sync="selectedEvStationInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="handleAddClick" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div
                            class="table-header"
                            id="TABLE_EDIT"
                            style="padding: 7px"
                            v-if="selectedEvStationInfo && selectedEvStationInfo.length > 0"
                        >
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedEvStationInfo.length === evStationInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedEvStationInfo.some((item) => item.ev_station_id === slotProps.data.ev_station_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                <!-- :sortable="true" -->
                <div v-if="colums_ev_station_name == true">
                    <Column field="ev_name" :header="'ชื่อสถานีชาร์จรถยนต์ไฟฟ้า'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="colums_ev_station_name == true">
                                <div
                                    v-if="
                                        dataTable.data.ev_station_name !== '' &&
                                        dataTable.data.ev_station_name !== null &&
                                        colums_ev_station_name == true
                                    "
                                >
                                    {{ dataTable.data.ev_station_name }}
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_brand"
                        :header="$t('ผู้ให้บริการ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                {{ dataTable.data.ev_station_brand }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_open_close"
                        :header="$t('เวลาให้บริการ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                {{ dataTable.data.ev_station_open_close }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_power"
                        :header="$t('กำลังไฟฟ้า')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div v-if="dataTable.data.ev_station_power == null">-</div>
                                <div v-else>{{ dataTable.data.ev_station_power }}</div>
                            </div>
                        </template>
                    </Column>
                </div>

                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_dealer"
                        :header="$t('ตัวแทนจำหน่าย')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.ev_station_dealer }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column field="country" :header="$t('เขต/อำเภอ')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.country }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="subdistrict"
                        :header="$t('แขวง/ตำบล')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.subdistrict }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="fire_station"
                        :header="$t('สถานีดับเพลิงและกู้ภัย')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.fire_station }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_status"
                        :header="$t('สถานะ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.ev_station_status }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lat == true">
                    <Column
                        field="ev_station_latitude"
                        :header="$t('latitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_event_lat == true">
                                <div v-if="dataTable.data.ev_station_latitude == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.ev_station_latitude).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lon == true">
                    <Column
                        field="ev_station_longitude"
                        :header="$t('longitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_event_lon == true">
                                <div v-if="dataTable.data.ev_station_longitude == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.ev_station_longitude).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div>
                    <Column
                        field="ev_station_description"
                        :header="$t('รายละเอียดข้อมูล')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div>
                                <div>{{ dataTable.data.ev_station_description }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_organize_contact_phone ||
                        columns_index ||
                        colums_ev_station_name ||
                        columns_ev_station_name ||
                        columns_system_name ||
                        columns_main_name ||
                        columns_organize_location ||
                        columns_organize_contact_name ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div
                                class="p-formgrid col_manege"
                                style="display: flex; justify-content: center"
                                v-if="checkNotAdminPermission(dataTable.data.user_organize)"
                            >
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            evStationsInfoModal = true;
                                            isEditMode = false;
                                            editData(dataTable.data.ev_station_id);
                                            temp = dataTable.data.ev_station_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.ev_station_id;
                                            deleteAt = '';
                                            alertDisplay(temp, deleteAt);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="evStationsInfoModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>

                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('io_modal_subtitle') }}</label>

                <div class="p-fluid p-mt-3">
                    <div class="p-grid">
                        <div class="p-field p-col">
                            <label for="ev_station_name">{{ $t('ev_station_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_name"
                                type="text"
                                v-model="ev_station_name"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_name && !io_ev_station_name
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_name && !ev_station_name">กรุณาระบุชื่อสถานี</small>
                        </div>

                        <div class="p-field p-col">
                            <label for="ev_station_brand">ชื่อผู้ให้บริการ<span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_brand"
                                type="text"
                                v-model="ev_station_brand"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_name && !io_ev_station_name
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_brand && !ev_station_brand">กรุณาระบุชื่อผู้ให้บริการ</small>
                        </div>

                        <div class="p-field p-col">
                            <label for="ev_station_dealer">ตัวแทน<span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_dealer"
                                type="text"
                                v-model="ev_station_dealer"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_name && !io_ev_station_name
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_dealer && !ev_station_dealer">กรุณาระบุข้อมูลตัวแทน</small>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-col-12 p-lg-4 p-mt-5" style="padding-top: 9.5px">
                                <span hidden>{{ url }}</span>
                                <div class="p-grid">
                                    <div class="p-col-8 p-lg-8">
                                        <Button
                                            @click="onFileChange"
                                            class="p-button-success"
                                            icon="pi pi-plus"
                                            label="เลือกไฟล์ภาพ"
                                            ref="TextBox_6"
                                            @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                        >
                                        </Button>

                                        <input
                                            style="visibility: hidden; display: none; text-overflow: ellipsis"
                                            type="file"
                                            id="imp_uploadImageFile"
                                            @change="onFileChange"
                                            class="inputzone"
                                            accept="image/*"
                                        />
                                    </div>
                                    <div class="p-col-4 p-lg-4" style="padding-top: 0">
                                        <Button
                                            @click="clearImage()"
                                            icon="pi pi-times"
                                            class="p-button-danger"
                                            style="width: auto"
                                            :label="$t('clearImage')"
                                            ref="TextBox_7"
                                            @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                        />
                                    </div>
                                </div>

                                <div id="preview">
                                    <img v-if="url" :src="url" />
                                </div>
                                <div id="imp_image" ref="imp_image" hidden></div>
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ev_station_open_close">เวลา <span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_open_close"
                                type="text"
                                v-model="ev_station_open_close"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_open_close && !io_ev_station_open_close
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_open_close && !ev_station_open_close">กรุณาระบุเวลาให้บริการ</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ev_station_power">กำลังไฟฟ้า <span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_power"
                                type="text"
                                v-model="ev_station_power"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_power && !io_ev_station_power
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_power && !ev_station_power">กรุณาระบุกำลังไฟฟ้า</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ev_quantity">จำนวน<span class="required-input">*</span></label>
                            <InputText
                                id="ev_quantity"
                                type="text"
                                v-model="ev_quantity"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_quantity && !io_ev_quantity
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_quantity && !ev_quantity">กรุณาระบุจำนวน</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ev_station_status">สถานะ<span class="required-input">*</span></label>
                            <InputText
                                id="ev_station_status"
                                type="text"
                                v-model="ev_station_status"
                                required="true"
                                :class="{
                                    'p-invalid': error_io_ev_station_status && !io_ev_station_status
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ev_station_status && !ev_station_status">กรุณาระบุสถานะ</small>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 1/8  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="io_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                optionLabel="province_name"
                                @change="someHandler('ch-province')"
                                :class="{
                                    'p-invalid': error_io_selectedProvince && !io_selectedProvince
                                }"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedProvince && !io_selectedProvince">{{
                                $t('io_selectedProvince_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="io_isDisabledAmphur == 1"
                                v-model="io_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                :class="{
                                    'p-invalid': error_io_selectedAmphur && !io_selectedAmphur
                                }"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedAmphur && !io_selectedAmphur">{{
                                $t('io_selectedAmphur_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="io_isDisabledTambon == 1"
                                v-model="io_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                :class="{
                                    'p-invalid': error_io_selectedTambon && !io_selectedTambon
                                }"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedTambon && !io_selectedTambon">{{
                                $t('io_selectedTambon_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2" style="margin-top: 5px">
                            <label for="fireStation">สถานีดับเพลิงและกู้ภัย<span class="required-input">*</span></label>
                            <Dropdown
                                v-model="FireStationSelected"
                                :options="FireStationOptions_AT"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                required="true"
                                :class="{ 'p-invalid': error_fireStation && !FireStationSelected }"
                            >
                                <template #value="FireStationOptions_AT">
                                    <div v-if="FireStationOptions_AT.value">
                                        <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                    </div>
                                    <span v-else>{{ FireStationOptions_AT.placeholder }}</span>
                                </template>
                                <template #option="FireStationOptions_AT">
                                    <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_fireStation && !FireStationSelected"> กรุณาเลือกสถานีดับเพลิงและกู้ภัย </small>
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 1/8  @input="inputMap_PAT_latlon" จบ-->

                    <div class="p-field p-col-12 p-lg-12 p-mt-2">
                        <label for="ev_station_address">ที่อยู่<span class="required-input">*</span></label>
                        <InputText
                            id="ev_station_address"
                            type="text"
                            v-model="ev_station_address"
                            required="true"
                            :class="{
                                'p-invalid': error_io_ev_station_address && !io_ev_station_address
                            }"
                            ref="TextBox_4"
                            @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                        />
                        <small class="p-invalid" v-if="error_ev_station_address && !ev_station_address">{{ $t('io_organizename_validate') }}</small>
                        <small class="p-invalid" v-if="error_io_selectedProvince && !io_selectedProvince">{{
                            $t('io_selectedProvince_validate')
                        }}</small>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="ev_station_description">รายละเอียด</label>
                            <InputText
                                id="ev_station_description"
                                type="text"
                                v-model="ev_station_description"
                                @input="acceptNumberPhone2"
                                :class="{
                                    'p-invalid': error_ev_station_description && ev_station_description.length !== 11
                                }"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="
                                    moveFocus($event, ev_station_description && ev_station_description !== '-' ? 'TextBox_14' : 'TextBox_15', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create" type="text" v-model="date_create" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update" type="text" v-model="date_update" autofocus disabled />
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/8  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="io_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="io_lat"
                                type="text"
                                v-model="io_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_15"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_13', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="io_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="io_lon"
                                type="text"
                                v-model="io_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_11', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/8  @input="inputMap_latlon" จบ-->
                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(io_lat, io_lon);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_17"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/8  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/8  จบ-->
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_21', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_21', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="isEditMode ? updateEvStationDataDetail() : saveEvStationDataDetail()"
                    ref="TextBox_21"
                    @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <!-- Manage communication modal -->
        <Dialog :modal="true" :visible.sync="showCommunicationModal" :style="{ width: '400px' }" :header="headerCommunication">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Communication')">
                <label>{{ $t('communication_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-field p-col">
                        <label for="communication_type">{{ $t('communication_type') }}<span class="required-input">*</span></label>
                        <Dropdown
                            v-model="communicationTypeSelect"
                            :options="communicationTypeOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                            :class="{
                                'p-invalid': error_communicationTypeSelect && communicationTypeSelect == null
                            }"
                        >
                            <template #value="communicationTypeOptions">
                                <div v-if="communicationTypeOptions.value">
                                    <div>{{ communicationTypeOptions.value.system_name }}</div>
                                </div>
                                <span v-else>{{ communicationTypeOptions.placeholder }}</span>
                            </template>
                            <template #option="communicationTypeOptions">
                                <div>{{ communicationTypeOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                        <small class="p-invalid" v-if="error_communicationTypeSelect && communicationTypeSelect == null"
                            >กรุณาระบุ ประเภทการสื่อสาร</small
                        >
                    </div>
                    <div class="p-field p-col">
                        <label for="communication_detail">{{ $t('communication_detail') }}</label>
                        <Textarea
                            id="communication_detail"
                            type="text"
                            rows="3"
                            v-model="communication_detail"
                            ref="TextBox_1_Communication"
                            @keyup.left="moveFocus($event, 'TextBox_3_Communication', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_Communication', 'Button')"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- แก้ไข สื่อสาร 1/3-->
                <Button
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearDataCommunication()"
                    ref="TextBox_2_Communication"
                    @keyup.left="moveFocus($event, 'TextBox_1_Communication', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_3_Communication', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveCommunicationData()"
                    ref="TextBox_3_Communication"
                    @keyup.left="moveFocus($event, 'TextBox_2_Communication', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Communication', 'Input')"
                />
            </template>
        </Dialog>

        <Dialog
            :modal="true"
            :header="$t('ResponseAreaModalHeader')"
            :visible.sync="showResponseArea"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
        >
            <response-area-table @selectResponseArea="selectResponseArea_passValue" :parentmessage="parentmessage_area"></response-area-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/8  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/8  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" autofocus />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->
        <Dialog :modal="true" :header="'รูปภาพหน่วยงาน'" :visible.sync="displayImageModal" :style="{ width: '400px' }">
            <div class="img-content p-mt-5 p-mb-5" style="text-align: center">
                <img :src="imgTable" alt="" v-if="imgTable" />
                <div v-else class="p-text-center">{{ $t('NoImageEquipment') }}</div>
            </div>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
import responseAreaTable from '../ResponseAreaTable';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';
import axios from 'axios';

export default {
    name: 'initial-organization',
    components: {
        organizeTable,
        organizeForm,
        responseAreaTable,
        mapArea,
        textFooter
    },
    data() {
        return {
            fireStation: null,
            ev_station_id: null,
            ev_station_address: '',
            error_ev_station_address: false,

            search_ev_station_name: '',
            search_ev_station_brand: '',
            search_ev_station_status: '',
            isEditMode: false,

            search_ev_station_dealer: '',
            error_ev_station_brand: false,
            error_ev_station_dealer: false,
            ev_station_open_close: '',
            ev_station_power: '',
            error_io_ev_quantity: false,
            ev_station_description: '',
            ev_quantity: '',
            error_io_ev_station_status: false,
            error_io_ev_station_address: false,

            ev_station_brand: '',
            service_provider: '',
            ev_station_status: '',
            error_fireStation: false,
            error_ev_station_name: false,
            error_ev_station_open_close: false,
            error_ev_station_power: false,
            error_ev_quantity: false,
            error_ev_station_status: false,
            error_ev_station_description: false,
            error_io_selectedProvince: false,
            error_io_selectedAmphur: false,
            error_io_selectedTambon: false,
            error_io_organizeTypeSelect: false,
            error_io_ev_station_name: false,
            error_contact_phone: false,
            error_contact_phone_office: false,
            error_io_ev_station_open_close: false,
            error_io_ev_station_power: false,

            ev_station_dealer: '',

            FireStationOptions: [],
            FireStationSelected: null,

            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],

            // ifh_FireStationOptions:[],
            ifh_FireStationSelected: null,
            error_ifh_FireStationSelected: false,

            responsiveOptions: [
                {
                    breakpoint: '1024px',
                    numVisible: 5
                },
                {
                    breakpoint: '768px',
                    numVisible: 3
                },
                {
                    breakpoint: '560px',
                    numVisible: 1
                }
            ],
            displayBasic2: false,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            evStationInfo_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,
            ev_station_name: '',
            filters: {},
            temp: null,
            showOrganize: false,
            showOrganize_Form: false,
            showResponseArea: false,
            showCommunicationModal: false,
            selectedEvStationInfo: [],
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            deleteAt: '',
            responseArea: {},
            disasterTable: {},
            communicationTable: {},
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],

            organizeTypeOptions: [],
            organizeTypeSelect: null,

            responseArea_table: [],
            header: this.$i18n.t('ev_modal_title_add'),
            headerCommunication: this.$i18n.t('communication_modal_title_add'),
            selectedData: '',

            communication_table: [],
            communicationTypeOptions: [],

            evStationsInfoModal: false,
            io_ev_station_name: '',
            io_location_detail: '',
            io_selectedOrganize: {},
            io_postcode: '',
            io_selectedProvince: null,
            io_selectedAmphur: null,
            io_selectedTambon: null,
            io_isDisabledAmphur: 1,
            io_isDisabledTambon: 1,
            io_selectedDisaster: null,
            io_organizeTypeSelect: null,
            io_lat: '',
            io_lon: '',
            io_email: '',
            io_fax: '',
            io_phonenumber: '',
            io_website: '',
            io_contact_name: '',
            io_contact_phone: '',
            io_organize_code: '',

            communicationTypeSelect: null,
            error_communicationTypeSelect: false,
            communication_detail: '',

            url: '',
            parentmessage_area: null,
            check_duplicate: '',
            error_email_format: false,
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            displayImageModal: false,
            imgTable: null,

            date_create: '',
            date_update: '',

            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/8  -->
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/8  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone_office_ext: false,

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ต้นสังกัด',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อสังกัด/หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสังกัด/หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 50,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 20 },
                ev_name: { cellWidth: 50 },
                ev_station_name: { cellWidth: 50 },
                system_name: { cellWidth: 50 },
                text_tel_detail: { cellWidth: 50 },
                main_name: { cellWidth: 50 },
                ev_station_latitude: { cellWidth: 50 },
                ev_station_longitude: { cellWidth: 50 },
                organize_contact_name: { cellWidth: 50 },
                date_create: { cellWidth: 50 },
                date_update: { cellWidth: 50 },
                ev_station_brand: { cellWidth: 50 },
                ev_station_open_close: { cellWidth: 50 },
                ev_station_power: { cellWidth: 50 }
            },

            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 20 },
                text_tel_detail: { cellWidth: 50 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อสถานีชาร์จรถยนต์ไฟฟ้า', dataKey: 'ev_name' },
                { title: 'ผู้ให้บริการ', dataKey: 'ev_station_brand' },
                { title: 'เวลาให้บริการ', dataKey: 'ev_station_open_close' },
                { title: 'กำลังไฟฟ้า', dataKey: 'ev_station_power' },
                { title: 'ตัวแทนจำหน่าย', dataKey: 'ev_station_dealer' },
                { title: 'แขวง/ตำบล', dataKey: 'subdistrict' },
                { title: 'เขต/อำเภอ', dataKey: 'country' },
                { title: 'สถานีดับเพลิงและกู้ภัย', dataKey: 'fire_station' },
                { title: 'สถานะ', dataKey: 'ev_station_status' },
                { title: 'ละติจูด', dataKey: 'ev_station_latitude' },
                { title: 'ลองจิจูด', dataKey: 'ev_station_longitude' },
                { title: 'รายละเอียดข้อมูล', dataKey: 'ev_station_description' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            colums_ev_station_name: true,
            columns_ev_station_name: true,
            columns_system_name: true,
            columns_main_name: true,
            columns_organize_location: true,
            columns_organize_contact_name: true,
            columns_organize_contact_phone: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'organize_image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'organize_image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        showResponseArea(val) {
            if (val == true) {
                if (this.responseArea_table.length > 0) {
                    this.parentmessage_area = this.responseArea_table;
                } else {
                    this.parentmessage_area = [];
                }
            }
        },
        // แก้ไข สื่อสาร 2/3
        showCommunicationModal(val) {
            if (val == '') {
                this.clearDataCommunication();
            } else {
                this.FocusRef_delay('TextBox_1_Communication', 'Input');
            }
        },

        async evStationsInfoModal(val) {
            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            if (this.isEditMode == false) {
                this.header = this.$i18n.t('ev_station_title_add');
                this.selectedData = '';
                this.ev_station_name = '';
                this.ev_station_brand = '';
                this.ev_station_dealer = '';
                this.ev_station_open_close = '';
                this.ev_station_power = '';
                this.ev_quantity = '';
                this.ev_station_status = '';
                this.io_selectedProvince = null;
                this.io_selectedAmphur = null;
                this.io_selectedTambon = null;
                this.FireStationSelected = null;
                this.ev_station_address = '';
                this.ev_station_description = '';
                this.io_lat = '';
                this.io_lon = '';
                this.date_create = this.formatThaiDate(currentDateString);
            }

            // console.log('this.isEditMode = ' + this.isEditMode);

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.io_ev_station_name != '' &&
                    this.io_organizeTypeSelect != null &&
                    this.io_selectedProvince != null
                ) {
                    this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.io_ev_station_name = '';
                            this.ev_station_name = '';
                            this.ev_station_brand = '';
                            this.ev_station_dealer = '';
                            this.ev_station_open_close = '';
                            this.ev_station_power = '';
                            this.ev_quantity = '';
                            this.ev_station_status = '';
                            this.io_selectedProvince = null;
                            this.io_selectedAmphur = null;
                            this.io_selectedTambon = null;
                            this.FireStationSelected = null;
                            this.ev_station_address = '';
                            this.ev_station_description = '';
                            this.io_lat = '';
                            this.io_lon = '';
                            this.selectedAmphur = null;
                            this.selectedTambon = null;
                            this.selectedProvince = null;

                            this.url = null;
                            this.evStationsInfoModal = false;

                            this.contact_phone = '';
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            this.date_create = '';
                            this.date_update = '';
                        } else {
                            this.evStationsInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-01' }
                        })
                        .then((response) => {
                            (this.organizeTypeOptions = response.data.data),
                                this.organizeTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create = this.checkDate_showEN(new Date());
                    this.date_update = this.checkDate_showEN(new Date());

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));

                    this.io_selectedOrganize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-01' }
                    })
                    .then((response) => {
                        this.organizeTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-01' }
                    })
                    .then((response) => {
                        this.organizeTypeOptions = response.data.data;
                    });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterOptions = response.data.data;
                    });
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.evStationsInfoModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async io_selectedProvince(val) {
            if (val != null) {
                this.io_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.io_isDisabledAmphur = 1;
                this.io_selectedAmphur = null;
            }
        },

        async io_selectedAmphur(val) {
            if (val != null) {
                this.io_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.io_isDisabledTambon = 1;
                this.io_selectedTambon = null;
            }
        },

        async io_selectedTambon(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-postcode',
                            tambon_id: val.tambon_id
                        }
                    })
                    .then((response) => {
                        if (val.tambon_id !== null && val.tambon_id !== 'null') {
                            this.io_postcode = response.data.data.postcode;
                        }
                    });
            } else {
                this.io_postcode = '';
            }
        },

        io_selectedDisaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },

        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.evStationInfo_Table = [];
            } else {
                this.evStationInfo_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
        // check_duplicate(val) {
        //   if (val == "duplicate organize") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลหน่วยงานไม่สำเร็จ",
        //     //   detail: "มีข้อมูลหน่วยงานนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลหน่วยงานไม่สำเร็จ",
        //           text: "มีข้อมูลหน่วยงานนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลหน่วยงาน",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลหน่วยงาน",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        // this.columnsSelectorDialog = this.columnsSelector
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // this.SaveEditPDF()
        // Doe PDF เลือกได้  4/5  จบ

        // this.initialData();
        this.checkRole = this.decodeJWT(localStorage.getItem('token')).permission_id;
        this.checkView_data = this.decodeJWT(localStorage.getItem('token')).view_data;
        this.checkAdd_data = this.decodeJWT(localStorage.getItem('token')).add_data;
        this.checkEdit_data = this.decodeJWT(localStorage.getItem('token')).edit_data;
        this.checkDelete_data = this.decodeJWT(localStorage.getItem('token')).delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `)

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.fetchFireStations();
    },
    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedEvStationInfo.map((item) => ({
                    ev_station_id: item.ev_station_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/update/ev/station/dates?user=${userId}`, {
                    body: {
                        selectedEvStationInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.evStationsInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลข้อมูลสถานีชาร์จรถยนต์ไฟฟ้าจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchEvStationInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedEvStationInfo = [...this.evStationInfo_Table];
            } else {
                this.selectedEvStationInfo = [];
            }
            this.$emit('selectedEvStationInfo', this.selectedEvStationInfo);
            // console.log('selectedEvStationInfo', this.selectedEvStationInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedEvStationInfo.some((item) => item.ev_station_id === row.ev_station_id)) {
                    this.selectedEvStationInfo.push(row);
                }
            } else {
                this.selectedEvStationInfo = this.selectedEvStationInfo.filter((item) => item.ev_station_id !== row.ev_station_id);
            }
            this.$emit('selectedEvStationInfo', this.selectedEvStationInfo);
            // console.log('selectedEvStationInfo', this.selectedEvStationInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        formatThaiDate(date) {
            if (!date) return null;
            const thaiMonths = [
                'มกราคม',
                'กุมภาพันธ์',
                'มีนาคม',
                'เมษายน',
                'พฤษภาคม',
                'มิถุนายน',
                'กรกฎาคม',
                'สิงหาคม',
                'กันยายน',
                'ตุลาคม',
                'พฤศจิกายน',
                'ธันวาคม'
            ];
            const d = new Date(date);
            const day = d.getDate();
            const month = thaiMonths[d.getMonth()];
            const year = d.getFullYear() + 543; // Convert to Thai Buddhist year
            return `${day} ${month} ${year}`;
        },

        async updateEvStationDataDetail(ev_station_id) {
            // console.log('ev_station_id = ' + ev_station_id);

            this.isEditMode = true;
            // console.log('Hello Update!');

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            this.$fire({
                title: 'ยืนยันการอัปเดตข้อมูล',
                text: 'คุณต้องการอัปเดตข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const evStationDataDetail = {
                            ev_station_id: this.ev_station_id,
                            ev_station_name: this.ev_station_name,
                            ev_station_open_close: this.ev_station_open_close,
                            ev_station_power: this.ev_station_power,
                            ev_station_description: this.ev_station_description,
                            ev_station_dealer: this.ev_station_dealer,
                            ev_station_address: this.ev_station_address,
                            ev_station_brand: this.ev_station_brand,
                            ev_station_status: this.ev_station_status,
                            io_lat: this.io_lat,
                            io_lon: this.io_lon,
                            FireStationSelected: this.FireStationSelected.fs_tname || null,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            subdistrict: this.io_selectedTambon.tambon_name,
                            country: this.io_selectedAmphur.amphur_name,
                            province: this.io_selectedProvince.province_name,
                            ev_quantity: this.ev_quantity,
                            ev_image: this.imp_uploadImageFile || ''
                        };

                        const payload = {
                            evStationDataDetail
                        };

                        // console.log('payload', payload);

                        const userId = this.getUsername();
                        this.loadingUpdate = true;
                        const response = await fetch(`${this.$url_service}/update/ev/station?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            if (errorData.message && errorData.message.includes('duplicate')) {
                                throw new Error('มีข้อมูลซ้ำในระบบ: ' + errorData.message);
                            } else {
                                throw new Error(`Network response was not ok: ${response.statusText}`);
                            }
                        }

                        const data = await response.json();
                        // console.log('Organization detail updated successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกอัปเดตเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.evStationsInfoModal = false;
                        });
                    } catch (error) {
                        console.error('Error updating organization detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการอัปเดตข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingUpdate = false;
                    }
                }
            });
        },
        handleAddClick() {
            this.isEditMode = false;
            this.evStationsInfoModal = true;
        },
        async saveEvStationDataDetail() {
            this.isEditMode = false;

            // Define the formatDate function
            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            let hasError = false;
            if (!this.ev_station_name) {
                this.error_ev_station_name = true;
                hasError = true;
            } else {
                this.error_ev_station_name = false;
            }
            if (!this.ev_station_brand) {
                this.error_ev_station_brand = true;
                hasError = true;
            } else {
                this.error_ev_station_brand = false;
            }
            if (!this.ev_station_dealer) {
                this.error_ev_station_dealer = true;
                hasError = true;
            } else {
                this.error_ev_station_dealer = false;
            }
            if (!this.ev_station_open_close) {
                this.error_ev_station_open_close = true;
                hasError = true;
            } else {
                this.error_ev_station_open_close = false;
            }
            if (!this.ev_station_power) {
                this.error_ev_station_power = true;
                hasError = true;
            } else {
                this.error_ev_station_power = false;
            }

            if (!this.ev_quantity) {
                this.error_ev_quantity = true;
                hasError = true;
            } else {
                this.error_ev_quantity = false;
            }

            if (!this.ev_station_status) {
                this.error_ev_station_status = true;
                hasError = true;
            } else {
                this.error_ev_station_status = false;
            }

            if (!this.io_selectedProvince) {
                this.error_io_selectedProvince = true;
                hasError = true;
            } else {
                this.error_io_selectedProvince = false;
            }

            if (!this.io_selectedAmphur) {
                this.error_io_selectedAmphur = true;
                hasError = true;
            } else {
                this.error_io_selectedAmphur = false;
            }

            if (!this.io_selectedTambon) {
                this.error_io_selectedTambon = true;
                hasError = true;
            } else {
                this.error_io_selectedTambon = false;
            }

            if (!this.FireStationSelected) {
                this.error_fireStation = true;
                hasError = true;
            } else {
                this.error_fireStation = false;
            }

            // If any required field has an error, return and do not proceed
            if (hasError) {
                return;
            }

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const evStationDataDetail = {
                            ev_station_name: this.ev_station_name,
                            ev_station_open_close: this.ev_station_open_close,
                            ev_station_power: this.ev_station_power,
                            ev_station_description: this.ev_station_description,
                            ev_station_dealer: this.ev_station_dealer,
                            ev_station_address: this.ev_station_address,
                            ev_station_brand: this.ev_station_brand,
                            ev_station_status: this.ev_station_status,
                            io_lat: this.io_lat,
                            io_lon: this.io_lon,
                            FireStationSelected: this.FireStationSelected.fs_tname || null,
                            user_organize: this.imp_organize?.id || '',
                            date_create: currentDateString,
                            date_update: currentDateString,
                            subdistrict: this.io_selectedTambon.tambon_name,
                            country: this.io_selectedAmphur.amphur_name,
                            province: this.io_selectedProvince.province_name,
                            ev_quantity: this.ev_quantity,
                            ev_image: this.imp_uploadImageFile || ''
                        };

                        const payload = {
                            evStationDataDetail
                        };

                        // console.log('payload', payload);

                        this.loadingCreate = true;
                        const userId = this.getUsername();
                        const response = await fetch(`${this.$url_service}/post/ev/stations/data?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            if (errorData.message && errorData.message.includes('duplicate')) {
                                throw new Error('มีข้อมูลซ้ำในระบบ: ' + errorData.message);
                            } else {
                                throw new Error(`Network response was not ok: ${response.statusText}`);
                            }
                        }

                        const data = await response.json();
                        // console.log('Organization detail posted successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.evStationsInfoModal = false;
                        });
                    } catch (error) {
                        console.error('Error posting organization detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        async fetchFireStations() {
            try {
                const response = await axios.post(`${this.$url_service}/get/fire/station`);
                if (response.data.code === 'success') {
                    this.FireStationOptions_AT = response.data.data;
                } else {
                    console.error('Error fetching fire stations:', response.data);
                }
            } catch (error) {
                console.error('Server error:', error);
            }
        },

        async Fire_Form() {
            if (this.selectedData == '') {
                this.ifh_FireStationSelected = null;
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser(),
                        province_id:
                            this.ifh_selectedProvince == null
                                ? ''
                                : this.ifh_selectedProvince.province_id == 'getall'
                                ? ''
                                : this.ifh_selectedProvince.province_id,
                        amphur_id:
                            this.ira_selectedAmphur == null
                                ? ''
                                : this.ira_selectedAmphur.amphur_id == 'getall'
                                ? ''
                                : this.ira_selectedAmphur.amphur_id,
                        tambon_id:
                            this.ira_selectedTambon == null
                                ? ''
                                : this.ira_selectedTambon.tambon_id == 'getall'
                                ? ''
                                : this.ira_selectedTambon.tambon_id
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;

                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchEvStationInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_16') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18') &&
                    !this.isFocused('TextBox_19')
                ) {
                    this.saveData();
                }
            } else if (ModalName === 'Modal_Communication') {
                this.saveCommunicationData();
            }
        },
        exportCSV() {
            // debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            if (this.filter !== '' && this.cloneTable.length > 0) {
                const searchTerm = this.filter.toLowerCase();

                this.evStationInfo_Table = this.cloneTable.filter((item) => {
                    return (
                        (item.ev_station_name && item.ev_station_name.toLowerCase().includes(searchTerm)) ||
                        (item.org_name && item.org_name.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_brand && item.ev_station_brand.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_dealer && item.ev_station_dealer.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_open_close && item.ev_station_open_close.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_power && item.ev_station_power.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_status && item.ev_station_status.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_address && item.ev_station_address.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_description && item.ev_station_description.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_latitude && item.ev_station_latitude.toLowerCase().includes(searchTerm)) ||
                        (item.ev_station_longitude && item.ev_station_longitude.toLowerCase().includes(searchTerm)) ||
                        (item.ev_quantity && item.ev_quantity.toLowerCase().includes(searchTerm)) ||
                        (item.date_create && item.date_create.toLowerCase().includes(searchTerm)) ||
                        (item.date_update && item.date_update.toLowerCase().includes(searchTerm))
                    );
                });

                // Update the index
                this.evStationInfo_Table.forEach((item, index) => {
                    item['index'] = index + 1;
                });
            } else {
                this.evStationInfo_Table = [...this.cloneTable];
                this.evStationInfo_Table.forEach((item, index) => {
                    item['index'] = index + 1;
                });
            }
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios.post(`${this.$url_service}/initial/organize`, {
                body: {
                    topic: 'get-table',
                    userOrg
                }
            });

            // console.log('this.getgetUserOrganize', this.getUserOrganize());
            //     // Doe : เพิ่ม ลำดับ 3/4
            //     .then((response) => {
            //         this.evStationInfo_Table = response.data.data;
            //         // Doe ค้นหา  4/6
            //         this.cloneTable = response.data.data;
            //         // Doe ค้นหา  4/6
            //         for (let i = 0; i < this.evStationInfo_Table.length; i++) {
            //             this.evStationInfo_Table[i]['index'] = i + 1;
            //         }
            //         // console.log("this.evStationInfo_Table",this.evStationInfo_Table)
            //         // Doe ช่องว่างใส่ ขีด
            //         this.formatData(this.evStationInfo_Table);
            //         // Doe ช่องว่างใส่ ขีด
            //     });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            // if (this.columns_disabled == true) {
            //     this.evStationInfo_Table = this.cloneTable;
            // } else {
            //     this.evStationInfo_Table = [];
            // }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].organize_location == null || data[index].organize_location == 'null' || data[index].organize_location == '') {
                    data[index].organize_location = '-';
                }
                if (
                    data[index].organize_contact_name == null ||
                    data[index].organize_contact_name == 'null' ||
                    data[index].organize_contact_name == ''
                ) {
                    data[index].organize_contact_name = '-';
                }
                if (
                    data[index].organize_contact_phone == null ||
                    data[index].organize_contact_phone == 'null' ||
                    data[index].organize_contact_phone == ''
                ) {
                    data[index].organize_contact_phone = '-';
                }
                if (data[index].main_name == null || data[index].main_name == 'null' || data[index].main_name == '') {
                    data[index].main_name = '-';
                }
                if (data[index].ev_station_latitude) {
                    data[index].ev_station_latitude = parseFloat(data[index].ev_station_latitude).toFixed(6);
                }
                if (data[index].ev_station_longitude) {
                    data[index].ev_station_longitude = parseFloat(data[index].ev_station_longitude).toFixed(6);
                }
                if (data[index].date_create == null || data[index].date_create == 'null' || data[index].date_create == '') {
                    data[index].date_create = '-';
                } else {
                    data[index].date_create = this.changeDateToThai(this.checkDate(data[index].date_create));
                }

                if (data[index].date_update == null || data[index].date_update == 'null' || data[index].date_update == '') {
                    data[index].date_update = '-';
                } else {
                    data[index].date_update = this.changeDateToThai(this.checkDate(data[index].date_update));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.evStationsInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearSearchField();
            this.clearData();
            this.ev_station_id = null;
        },

        acceptNumberCTPhone() {
            var x = this.io_contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.io_contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        // acceptNumberPhone() {
        //   var x = this.io_phonenumber
        //     .replace(/\D/g, "")
        //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //   this.io_phonenumber = !x[2]
        //     ? x[1]
        //     : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        // },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.io_selectedAmphur = null;
                this.io_postcode = '';
            }
            if (message == 'ch-amphur') {
                this.io_selectedTambon = null;
                this.io_postcode = '';
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('imp_uploadImageFile').value = '';
        },

        onFileChange(e) {
            document.getElementById('imp_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    if (e.target.files[0].type.split('/')[0] === 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                this.imp_uploadImageFile = dataurl; // Store base64 image data
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('imp_uploadImageFile').value = '';
                    }
                } else {
                    this.url = null;
                }
            }
        },

        // selectedOrganize_passValue(variable) {
        //   this.showOrganize = false;
        //   if (this.evStationsInfoModal == false) {
        //     this.selectedOrganize = {
        //       id: variable.organize_id,
        //       name: variable.ev_station_name,
        //     };
        //   } else {
        //     this.io_selectedOrganize = {
        //       id: variable.organize_id,
        //       name: variable.ev_station_name,
        //     };
        //   }
        // },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.evStationsInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.ev_station_name
                };
            } else {
                this.io_selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.ev_station_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            ev_station_name: variable[i].ev_station_name
                        });
                    }
                }
            }
        },

        selectResponseArea_passValue(variable) {
            this.showResponseArea = false;
            this.responseArea_table = variable;
        },
        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },
        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.io_lat = variable.lat;
            this.io_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.io_lat",this.io_lat)
            // console.log("this.io_lon",this.io_lon)
            if (this.io_lat !== null && this.io_lon !== null && this.io_lat !== '' && this.io_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/8  -->
        async inputMap_latlon() {
            if (this.io_lat !== '' && this.io_lat !== null && this.io_lon !== '' && this.io_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.io_lat}/lon=${this.io_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.io_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.io_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.io_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.io_selectedProvince = null;
                                this.io_selectedAmphur = null;
                                this.io_selectedTambon = null;
                            }

                            // console.log("this.io_selectedProvince",this.io_selectedProvince)
                            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
                            // console.log("this.io_selectedTambon",this.io_selectedTambon)
                        } else {
                            this.io_selectedProvince = null;
                            this.io_selectedAmphur = null;
                            this.io_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.io_selectedProvince = null;
                this.io_selectedAmphur = null;
                this.io_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            // console.log("this.io_selectedProvince",this.io_selectedProvince)
            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
            // console.log("this.io_selectedTambon",this.io_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.io_selectedProvince) {
                this.sP.push(this.io_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.io_selectedAmphur) {
                this.sA.push(this.io_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.io_selectedProvince == null) {
                this.io_lat = '';
                this.io_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.io_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.io_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.io_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.io_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.io_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.io_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.io_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.io_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.io_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.io_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.io_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.io_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.io_lat = '';
                    this.io_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/8  จบ-->

        // แก้ไข สื่อสาร 3/3
        saveCommunicationData() {
            if (this.communicationTypeSelect == null) {
                this.error_communicationTypeSelect = true;
            } else {
                this.showCommunicationModal = false;
                this.communication_table.push({
                    system_name: this.communicationTypeSelect.system_name,
                    detail: this.communication_detail
                });

                this.clearDataCommunication();
            }
        },
        clearDataCommunication() {
            if (this.selectedData != '') {
                // console.log("123")
                this.communicationTypeSelect = null;
                this.communication_detail = '';
                this.showCommunicationModal = false;
                this.error_communicationTypeSelect = false;
            } else {
                // console.log("456")
                this.communicationTypeSelect = null;
                this.communication_detail = '';
                this.showCommunicationModal = false;
                this.error_communicationTypeSelect = false;
            }
        },
        // แก้ไข สื่อสาร 3/3 จบ

        async searchEvStationInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.cloneTable = [];
            this.loading = true;

            try {
                let response;

                response = await this.axios.post(`${this.$url_service}/initial/ev_station/detail`, {
                    userOrg,
                    search_ev_station_name: this.search_ev_station_name || '',
                    search_ev_station_dealer: this.search_ev_station_dealer || '',
                    search_ev_station_brand: this.search_ev_station_brand || '',
                    search_ev_station_status: this.search_ev_station_status || '',
                    selectedProvince: this.selectedProvince?.province_name || '',
                    selectedAmphur: this.selectedAmphur?.amphur_name || '',
                    selectedTambon: this.selectedTambon?.tambon_name || '',
                    fireStation: this.fireStation?.fs_tname || ''
                });

                // console.log('userOrg', userOrg);

                if (response.data && response.data.length > 0) {
                    this.evStationInfo_Table = response.data;

                    // Add an index to each row
                    this.evStationInfo_Table.forEach((item, index) => {
                        item.index = index + 1;
                    });

                    // Format the data (e.g., replace empty fields with dashes)
                    this.formatData(this.evStationInfo_Table);

                    // Clone the data for further use
                    this.cloneTable = [...this.evStationInfo_Table];

                    // Set up search text and footer
                    this.setSearchText_Footer();

                    // Perform any necessary searches/filtering
                    this.search();
                } else {
                    // If no data is returned, clear the table
                    this.evStationInfo_Table = [];
                }
            } catch (error) {
                console.error('Error fetching EV station details:', error);
            } finally {
                this.loading = false;
            }

            if (this.columns_disabled) {
                this.evStationInfo_Table = [...this.cloneTable];
            } else {
                this.evStationInfo_Table = [];
            }

            this.search();
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.ev_station_name !== '' ||
                this.organizeTypeSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ต้นสังกัด' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อสถานีชาร์จรถยนต์ไฟฟ้า' && this.ev_station_name !== '') {
                        element.textShow = this.ev_station_name;
                    }
                    if (element.DataName === 'ประเภทสังกัด/หน่วยงาน' && this.organizeTypeSelect !== null) {
                        element.textShow = this.organizeTypeSelect.system_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                }

                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.ev_station_name !== undefined) {
                    text += element.ev_station_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt === 'evStation') {
                this.displayConfirmation = false;
                this.evStationInfo_Table = this.evStationInfo_Table.filter((val) => val !== this.evStationDelete);
            }

            try {
                const userId = this.getUsername();
                await this.axios.post(`${this.$url_service}/delete/ev_station/data?user=${userId}`, {
                    ev_station_id: this.temp
                });

                this.displayConfirmation = false;
                this.searchEvStationInfo();

                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } catch (error) {
                console.error('Error deleting organization data:', error);
                this.$fire({
                    type: 'error',
                    title: 'ลบข้อมูลไม่สำเร็จ',
                    text: 'เกิดข้อผิดพลาดในการลบข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า',
                    timer: 3000,
                    confirmButtonColor: '#E74C3C'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();

            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];

            //Check null value
            if (
                this.io_ev_station_name == '' ||
                this.io_organizeTypeSelect == null ||
                this.io_selectedProvince == null ||
                this.io_selectedAmphur == null ||
                this.io_selectedTambon == null
            ) {
                if (this.io_ev_station_name == '') {
                    this.error_io_ev_station_name = true;
                }
                if (this.io_organizeTypeSelect == null) {
                    this.error_io_organizeTypeSelect = true;
                }
                if (this.io_selectedProvince == null) {
                    this.error_io_selectedProvince = true;
                }
                if (this.io_selectedAmphur == null) {
                    this.error_io_selectedAmphur = true;
                }
                if (this.io_selectedTambon == null) {
                    this.error_io_selectedTambon = true;
                }
            } else {
                var check;
                if (this.io_email != '') {
                    var re =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    check = re.test(this.io_email);
                    // console.log("Email validate : " + check);
                }

                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (check == false) {
                    this.error_email_format = true;
                } else {
                    if (!this.error_contact_phone && !this.error_contact_phone_office) {
                        if (this.selectedData == '') {
                            // โหลดเพิ่มแก้ไข 4/8
                            this.loadingCreate = true;
                            // โหลดเพิ่มแก้ไข 4/8 จบ

                            await this.axios
                                .post(`${this.$url_service}/initial/organize?user=${userId}`, {
                                    body: {
                                        topic: 'add-organize',
                                        userOrg,
                                        code: this.io_organize_code,
                                        name: this.io_ev_station_name,
                                        type: this.io_organizeTypeSelect.system_id,
                                        image: this.$refs.io_image.innerText,
                                        organize: this.io_selectedOrganize.id,
                                        location: this.io_location_detail,
                                        location_id: this.io_selectedTambon,
                                        phone: this.io_phonenumber,
                                        tel_detail: this.iev_phone,
                                        fax: this.io_fax,
                                        mail: this.io_email,
                                        lat: this.io_lat,
                                        lon: this.io_lon,
                                        website: this.io_website,
                                        contact_phone: this.io_contact_phone,
                                        contact_name: this.io_contact_name,
                                        disastertable: this.disaster_table,
                                        responsetable: this.responseArea_table,
                                        communicationtable: this.communication_table
                                    }
                                })
                                .then((response) => {
                                    (this.check_duplicate = response.data.message),
                                        // this.initialData();
                                        this.searchEvStationInfo();

                                    // โหลดเพิ่มแก้ไข 5/8
                                    this.loadingCreate = false;
                                    // โหลดเพิ่มแก้ไข 5/8 จบ

                                    // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                                    // console.log("this.check_duplicate ",this.check_duplicate)
                                    if (this.check_duplicate == 'duplicate organize') {
                                        this.$fire({
                                            type: 'error',
                                            title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                            text: 'มีข้อมูลนี้ในระบบแล้ว',
                                            timer: 3000,
                                            confirmButtonColor: '#d33'
                                        });
                                    } else {
                                        this.$fire({
                                            title: 'เพิ่มข้อมูลสำเร็จ',
                                            text: 'ข้อมูลหน่วยงาน',
                                            type: 'success',
                                            timer: 3000,
                                            confirmButtonColor: '#28B463'
                                        });
                                    }
                                });
                            // console.log("Save data");
                            this.tempFor_displayConfirmationCloseModal = 'add';
                            this.evStationsInfoModal = false;
                        } else {
                            if (this.$refs.io_image.innerText == '') {
                                this.$refs.io_image.innerText = this.url;
                            } else {
                                this.$refs.io_image.innerText = this.$refs.io_image.innerText;
                            }
                            // โหลดเพิ่มแก้ไข 6/8 จบ
                            this.loadingCreate = true;
                            // โหลดเพิ่มแก้ไข 6/8 จบ
                            await this.axios
                                .post(`${this.$url_service}/initial/organize?user=${this.getUsername()}`, {
                                    body: {
                                        topic: 'edit-organize',
                                        id: this.temp,
                                        code: this.io_organize_code,
                                        name: this.io_ev_station_name,
                                        type: this.io_organizeTypeSelect.system_id,
                                        image: this.$refs.io_image.innerText,
                                        organize: this.io_selectedOrganize.id,
                                        location: this.io_location_detail,
                                        location_id: this.io_selectedTambon,
                                        phone: this.io_phonenumber,
                                        tel_detail: this.iev_phone,
                                        fax: this.io_fax,
                                        mail: this.io_email,
                                        lat: this.io_lat,
                                        lon: this.io_lon,
                                        website: this.io_website,
                                        contact_phone: this.io_contact_phone,
                                        contact_name: this.io_contact_name,
                                        disastertable: this.disaster_table,
                                        responsetable: this.responseArea_table,
                                        communicationtable: this.communication_table
                                    }
                                })
                                .then(() =>
                                    // this.initialData()
                                    this.searchEvStationInfo()
                                );
                            // โหลดเพิ่มแก้ไข 7/8 จบ
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 7/8 จบ
                            // this.$toast.add({
                            //   severity: "success",
                            //   summary: "แก้ไขข้อมูลสำเร็จ",
                            //   detail: "ข้อมูลหน่วยงาน",
                            //   life: 3000,
                            // });
                            this.$fire({
                                type: 'success',
                                title: 'แก้ไขข้อมูลสำเร็จ',
                                text: 'ข้อมูลหน่วยงาน',
                                timer: 3000,
                                confirmButtonColor: '#28B463'
                            });
                            // console.log("Edit data");
                            this.evStationsInfoModal = false;
                        }
                    }
                }
            }
        },

        async editData(ev_station_id) {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('Edit mode activated for ev_station_id:', ev_station_id);
            this.isEditMode = true;
            if (this.isEditMode === true) {
                this.header = this.$i18n.t('ev_station_title_edit');
            }

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            // console.log('this.isEditMode:', this.isEditMode);

            // Store the ev_station_id for later use
            this.ev_station_id = ev_station_id;

            try {
                // console.log('Making API request...');
                const response = await this.axios.post(`${this.$url_service}/search/edit/ev/station`, {
                    ev_station_id: ev_station_id
                });

                // console.log('API response received:', response);

                if (response.data && response.data.data) {
                    const data = response.data.data;

                    // console.log('Data found:', data);

                    // Populate the form with the retrieved data
                    this.selectedData = data;
                    this.ev_station_id = data.EvStationDataDetail.ev_station_id || '';
                    this.ev_station_name = data.EvStationDataDetail.ev_station_name || '';
                    this.ev_station_brand = data.EvStationDataDetail.ev_station_brand || '';
                    this.ev_station_dealer = data.EvStationDataDetail.ev_station_dealer || '';
                    this.ev_station_open_close = data.EvStationDataDetail.ev_station_open_close || '';
                    this.io_selectedProvince = { province_name: data.EvStationDataDetail.province || '' };
                    this.io_selectedAmphur = { amphur_name: data.EvStationDataDetail.country || '' };
                    this.io_selectedTambon = { tambon_name: data.EvStationDataDetail.subdistrict || '' };
                    this.ev_station_power = data.EvStationDataDetail.ev_station_power || '';
                    this.ev_quantity = data.EvStationDataDetail.ev_quantity || '';
                    this.ev_station_status = data.EvStationDataDetail.ev_station_status || '';
                    this.FireStationSelected = { fs_tname: data.EvStationDataDetail.fire_station || '' };
                    this.ev_station_address = data.EvStationDataDetail.ev_station_address || '';
                    this.ev_station_description = data.EvStationDataDetail.ev_station_description || '';
                    this.url = data.EvStationDataDetail.ev_image || '';
                    this.imp_uploadImageFile = data.EvStationDataDetail.ev_image || '';
                    this.date_create = this.formatThaiDate(data.EvStationDataDetail.date_create) || '';
                    this.date_update = this.formatThaiDate(currentDateString) || '';
                    this.io_lat = data.EvStationDataDetail.ev_station_latitude || '';
                    this.io_lon = data.EvStationDataDetail.ev_station_longitude || '';

                    // Remove existing focus
                    document.activeElement.blur();

                    // Set focus to the first input field
                    this.$nextTick(() => {
                        if (this.$refs.TextBox_1) {
                            this.$refs.TextBox_1.focus();
                        }
                    });

                    // Set the form to edit mode and update the header
                    this.isEditMode = true;
                    if (this.isEditMode === true) {
                        this.header = this.$i18n.t('ev_station_title_edit');
                    }
                } else {
                    console.error('No data found for the given ev_station_id:', ev_station_id);
                }
            } catch (error) {
                console.error('Error fetching ev station data:', error);
            }
        },

        clearData() {
            this.url = '';
            this.imp_uploadImageFile = '';
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;

            this.io_selectedProvince = null;
            this.io_selectedAmphur = null;
            this.io_selectedTambon = null;
            this.FireStationSelected = null;

            this.ev_station_name = '';
            this.ev_station_brand = '';
            this.ev_station_dealer = '';
            this.ev_station_open_close = '';
            this.ev_station_power = '';
            this.ev_quantity = '';
            this.ev_station_status = '';
            this.ev_station_address = '';
            this.ev_station_description = '';
            this.io_lat = '';
            this.io_lon = '';

            // Clear any potential errors related to the fields
            this.error_ev_station_name = false;
            this.error_ev_station_brand = false;
            this.error_ev_station_dealer = false;
            this.error_ev_station_open_close = false;
            this.error_ev_station_power = false;
            this.error_ev_quantity = false;
            this.error_ev_station_status = false;
            this.error_ev_station_address = false;
            this.error_io_selectedProvince = false;
            this.error_io_selectedAmphur = false;
            this.error_io_selectedTambon = false;
            this.error_fireStation = false;
            this.error_ev_station_name = false;
            this.error_ev_station_brand = false;
            this.error_ev_station_dealer = false;
            this.error_ev_station_open_close = false;
            this.error_ev_station_power = false;
            this.error_ev_quantity = false;
            this.error_ev_station_status = false;
            this.error_io_selectedProvince = false;
            this.error_io_selectedAmphur = false;
            this.error_io_selectedTambon = false;
            this.error_fireStation = false;

            // Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('io_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.evStationsInfoModal = false;
                this.selectedData = '';
                this.setDefault();
                // Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        // setDefault() {
        //     this.tempFor_displayConfirmationCloseModal = '';
        //     document.getElementById('imp_uploadImageFile').value = '';
        //     this.url = null;

        //     // Clear form fields
        //     this.ev_station_name = '';
        //     this.ev_station_brand = '';
        //     this.ev_station_dealer = '';
        //     this.ev_station_open_close = '';
        //     this.ev_station_power = '';
        //     this.ev_quantity = '';
        //     this.ev_station_status = '';
        //     this.ev_station_address = '';
        //     this.ev_station_description = '';
        //     this.io_lat = '';
        //     this.io_lon = '';
        //     this.date_create = this.currentDate();
        //     this.date_update = this.currentDate();
        //     this.io_selectedProvince = null;
        //     this.io_selectedAmphur = null;
        //     this.io_selectedTambon = null;
        //     this.FireStationSelected = null;

        //     // Clear contact fields
        //     this.contact_phone = '';
        //     this.contact_phone_office = '';
        //     this.contact_phone_office_ext = '';

        //     // Clear error states
        //     this.error_io_ev_station_name = false;
        //     this.error_ev_station_brand = false;
        //     this.error_ev_station_dealer = false;
        //     this.error_io_ev_station_open_close = false;
        //     this.error_io_ev_station_power = false;
        //     this.error_io_ev_quantity = false;
        //     this.error_io_ev_station_status = false;
        //     this.error_io_ev_station_address = false;
        //     this.error_io_selectedProvince = false;
        //     this.error_io_selectedAmphur = false;
        //     this.error_io_selectedTambon = false;
        //     this.error_fireStation = false;
        //     this.error_contact_phone = false;
        //     this.error_contact_phone_office = false;
        //     this.error_contact_phone_office_ext = false;
        //     this.error_latlon_country = false;
        //     this.error_latlon_land = false;
        //     this.error_latlon_P = false;
        //     this.error_latlon_A = false;
        //     this.error_latlon_T = false;

        //     // Reset modal visibility
        //     this.evStationsInfoModal = false;
        // },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            document.getElementById('imp_uploadImageFile').value = '';
            this.url = null;

            // Clear form fields
            this.ev_station_name = '';
            this.ev_station_brand = '';
            this.ev_station_dealer = '';
            this.ev_station_open_close = '';
            this.ev_station_power = '';
            this.ev_quantity = '';
            this.ev_station_status = '';
            this.ev_station_address = '';
            this.ev_station_description = '';
            this.io_lat = '';
            this.io_lon = '';
            this.date_create = this.currentDate();
            this.date_update = this.currentDate();
            this.io_selectedProvince = null;

            // Clear dropdown fields

            this.fireStation = null;

            // Optionally clear the filtered values in dropdowns
            this.dropdownClearFilerValue += 1;

            // Clear contact fields
            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            // Clear error states
            this.error_io_ev_station_name = false;
            this.error_ev_station_brand = false;
            this.error_ev_station_dealer = false;
            this.error_io_ev_station_open_close = false;
            this.error_io_ev_station_power = false;
            this.error_io_ev_quantity = false;
            this.error_io_ev_station_status = false;
            this.error_io_ev_station_address = false;
            this.error_io_selectedProvince = false;
            this.error_io_selectedAmphur = false;
            this.error_io_selectedTambon = false;
            this.error_fireStation = false;
            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;
            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            // Reset modal visibility
            this.evStationsInfoModal = false;
        },

        async clearSearchField() {
            this.ms = false;
            this.ev_station_status = '';
            this.ev_station_brand = '';
            this.fireStation = null;
            this.ev_station_dealer = '';
            this.search_ev_station_name = '';
            this.search_ev_station_dealer = '';
            this.search_ev_station_brand = '';
            this.search_ev_station_status = '';

            this.ev_station_name = '';
            this.organizeTypeSelect = null;
            this.selectedOrganize = {};
            this.selectedProvince = null;
            this.selectedAmphur = null;
            this.selectedTambon = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.evStationInfo_Table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
            this.isEditMode = false;
            this.clearData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.ev_station_name = '';
                this.organizeTypeSelect = null;
                this.selectedOrganize = {};
                this.selectedProvince = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(io_lat, io_lon) {
            let lat = io_lat;
            let lon = io_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province, FireStationSelected) {
            if (FireStationSelected) {
                this.FSS = FireStationSelected;
            } else {
                this.FSS = {};
            }

            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },
        //  Doe เพิ่มหมุด map V.2 7/8  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.io_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.io_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.io_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.io_selectedProvince = null;
                this.io_selectedAmphur = null;
                this.io_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.io_selectedProvince",this.io_selectedProvince)
            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
            // console.log("this.io_selectedTambon",this.io_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 7/8  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 70;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.colums_ev_station_name = false;
                this.columns_ev_station_name = false;
                this.columns_system_name = false;
                this.columns_main_name = false;
                this.columns_organize_location = false;
                this.columns_event_lat = false;
                this.columns_event_lon = false;
                this.columns_organize_contact_name = false;
                this.columns_organize_contact_phone = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'organize_image') {
                        this.colums_ev_station_name = true;
                    } else if (!getData.includes('organize_image')) {
                        this.colums_ev_station_name = false;
                    }

                    if (element == 'ev_station_name') {
                        this.columns_ev_station_name = true;
                    } else if (!getData.includes('ev_station_name')) {
                        this.columns_ev_station_name = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'main_name') {
                        this.columns_main_name = true;
                    } else if (!getData.includes('main_name')) {
                        this.columns_main_name = false;
                    }

                    if (element == 'organize_location') {
                        this.columns_organize_location = true;
                    } else if (!getData.includes('organize_location')) {
                        this.columns_organize_location = false;
                    }

                    if (element == 'ev_station_latitude') {
                        this.columns_event_lat = true;
                    } else if (!getData.includes('ev_station_latitude')) {
                        this.columns_event_lat = false;
                    }

                    if (element == 'ev_station_longitude') {
                        this.columns_event_lon = true;
                    } else if (!getData.includes('ev_station_longitude')) {
                        this.columns_event_lon = false;
                    }

                    if (element == 'organize_contact_name') {
                        this.columns_organize_contact_name = true;
                    } else if (!getData.includes('organize_contact_name')) {
                        this.columns_organize_contact_name = false;
                    }

                    // if (element == "organize_contact_phone") {
                    //   this.columns_organize_contact_phone = true
                    // } else if(!getData.includes("organize_contact_phone")){
                    //   this.columns_organize_contact_phone = false
                    // }
                    if (element == 'text_tel_detail') {
                        this.columns_organize_contact_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_organize_contact_phone = false;
                    }

                    if (element == 'date_create') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 8/8  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 8/8  จบ--> */
.table_row {
    text-align: center;
}
.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }

    .Or_disasterOptions {
        width: 14.5rem;
        overflow-y: scroll;
    }
    .Or_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .Or_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .Or_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}
.p-field {
    margin-bottom: 0rem;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
